import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs, redirect } from 'react-router';
import { getSystemQuery } from '~/shared/api/system.queries';
import { checkAuthorization } from '~/shared/auth/auth-utils';
import { createSystemRoute } from '~/shared/models/create-routes';
import { ResourceNameIdConverter } from '~/shared/models/ResourceNameIdConverter';
import { SystemModel } from '~/shared/models/system/SystemModel';
import { assertIsDefined } from '~/types/assert-type';

// TODO: Remove after transition period
export const systemLegacyLoader =
  (queryClient: QueryClient) =>
  async ({ params, request }: LoaderFunctionArgs): Promise<null | Response> => {
    await checkAuthorization(queryClient, request);

    const { systemId: legacySystemId } = params;

    assertIsDefined(legacySystemId);

    const systemName = window.atob(legacySystemId || '');

    const systemId = ResourceNameIdConverter.systemNameToId(systemName);

    const system = await queryClient.ensureQueryData(getSystemQuery(systemId));

    const systemModel = new SystemModel({ system });

    return redirect(createSystemRoute(systemModel.id));
  };
